import type {
  Insight,
  InsightAxis,
  InsightAxisResponse,
  InsightPayload,
  InsightResponse,
} from '@/types/insights';

export const toInsightAxis = (axis: InsightAxisResponse): InsightAxis => {
  if (axis.generation_status !== 'processed') {
    return { generation_status: axis.generation_status, axis: axis.axis };
  }
  if (axis.id === null) {
    return { generation_status: 'error', axis: axis.axis };
  }
  return { ...axis, generation_status: 'processed', id: axis.id };
};

export const normalizeInsight = (insight: InsightResponse): Insight => {
  const { payload, ...rest } = insight;
  if (payload === undefined) return rest;
  return {
    ...rest,
    payload: {
      personal_interest: toInsightAxis(payload.personal_interest),
      organization_interest: toInsightAxis(payload.organization_interest),
      outside_interest: toInsightAxis(payload.outside_interest),
    },
  };
};

export const insightPayloadAxes = (payload: InsightPayload): InsightAxis[] => [
  payload.personal_interest,
  payload.organization_interest,
  payload.outside_interest,
];

export const hasProcessingAxis = (payload: InsightPayload | undefined) =>
  payload !== undefined &&
  insightPayloadAxes(payload).some(
    axis => axis.generation_status === 'processing',
  );
